<template>
  <!-- 提示信息弹窗 -->
  <div class="pop">
    <div class="pop-container">
      <div class="pop-container-title">
        <div class="title-wrap">
          <div class="title-icon"></div>
          <span class="title-text">客服</span>
        </div>
        <div class="pop-close" @click="closeModal"></div>
      </div>
      <div class="pop-container-content">
        <el-form class="selectGame" :model="formData" :rules="rules" ref="ruleForm">
          <el-form-item prop="game_base_id">
            <el-select
              placeholder="請先選擇遊戲"
              @change="selectGame"
              style="width: 240px"
              v-model="formData.game_base_id"
            >
              <template v-for="(item, index) in gameList">
                <el-option
                  :key="index"
                  :label="item.game_name"
                  :value="item.game_base_id"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="pop-container-action" @click="nextStep">
        下一步
      </div>
    </div>
  </div>
</template>

<script>
require("../../../elementUI/elementUI");

export default {
  data() {
    return {
      gameList: [],
      rules: {
        // 表单验证规则
        game_base_id: [
          { required: true, message: "請先選擇遊戲" }
        ],
      },
    };
  },
  props: {
    formData: {
      type: Object,
      default: () => ({}),
    }
  },
  methods: {
    commonGameList() {
      this.$apis.service.commonGameList().then((res) => {
				if (res.data.code == 0 && res.data.data) {
					this.gameList = res.data.data;
				}
			});
    },
    closeModal() {
      this.$emit("closeModal");
    },
    // 选择游戏
    selectGame(item) {
      const temp = this.gameList.filter((value) => Number(item) === value.game_base_id)
      if (temp && temp.length) {
        this.formData.type = temp[0].account_domain === 7 ? 2 : 1;
      }
    },
    // 下一步
    nextStep() {
      this.$refs['ruleForm'].validate((valid) => {
        if(valid) {
          this.$emit("nextStep");
        }
      })
    },
  },
  created() {
    this.commonGameList();
  }
};
</script>

<style lang="scss">
@import "../../../elementUI/elementUI.scss";
.selectGame {
  .el-form-item__label {
    line-height: 40px;
  }
}
</style>
<style lang="scss" scoped>
.pop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 20;

  &-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 300px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.15);
    padding-bottom: 80px;

    &-title {
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 30px;
      border-bottom: 1px solid #ebebeb;

      .title-wrap {
        display: flex;
        align-items: center;

        .title-icon {
          width: 4px;
          height: 20px;
          background: #2da2d4;
          border-radius: 2px;
          margin-right: 12px;
        }

        .title-text {
          font-size: 16px;
          color: #444;
        }
      }

      .pop-close {
        @extend %bgCover;
        width: 20px;
        height: 20px;
        background-image: url("../../images/close.png");
        cursor: pointer;
      }
    }

    &-content {
      padding: 40px 30px 20px;
      text-align: center;
      line-height: 24px;
      word-break: break-word;
    }
    &-action {
      width: 150px;
      height: 40px;
      line-height: 40px;
      background: #2db2de;
      border-radius: 52px;
      text-align: center;
      color: #fff;
      margin: 0 auto;
      cursor: pointer;
      font-size: 20px;
    }
  }
}
</style>
